import nuskin       from './namespace.js';

import storage      from './storage.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace runConfigService
 */
var runConfigService = function() {
    var RUN_CONFIG = storage.metadata.RUN_CONFIG;

// -----------------------------------------
//
//      Non exported functions
//
// -----------------------------------------

    function getStorageObject(){
        var storageObj = null;
        if (storage !== undefined){
            storageObj = storage(storage.metadata.RUN_CONFIG);
        }
        return storageObj;
    }

    function writeStorageObj(obj){
        if (storage !== undefined) {
            if (obj !== null){
                storage(RUN_CONFIG, obj);
            }
            else {
                storage(RUN_CONFIG, null);
            }
        }
    }

    /**
     * Sets certain runConfig flags specific to the assessment. Checks to
     *  see if this is being run inside of AEM or is strictly assessment app.
     */
    function setAssessmentAppMode(runConfig) {
        if (runConfig.assessmentApp) {
            runConfig.alternateHomeUrl = runConfig.phoneGap ? 'index.html#/home': '/#/home';
            runConfig.assessmentPurchase = runConfig.phoneGap ? 'index.html#/purchase': '/#/purchase';
            runConfig.cartUrl = runConfig.phoneGap ? 'index.html#/cart' : '/#/cart';
            runConfig.landing = runConfig.phoneGap ? 'index.html#/cart' : '/#/cart';
            runConfig.hideSearch = true;
            runConfig.noSignupMode = true;
        } else {
            runConfig.hideSearch = false;
            runConfig.noSignupMode = false;
            runConfig.alternateHomeUrl = null;
        }
        return runConfig;
    }


    function getCurrencyCode(inCountry, runConfig) {
        var currencyCode = null;

        if (inCountry && (inCountry != runConfig.country || !runConfig.currencyCode)) {
            $.ajax({
                type: "GET",
                url: runConfig.baseUrl + '/content/configuration/currencies.service.' + inCountry + '.json',
                dataType: "json",
                async: false,
                success: function(data) {
                    currencyCode = data[0].currencyCode;
                },
                error: function(xhr) {
                    console.log("could not get the market's currency! error:"+xhr);
                }
            });
        } else {
            currencyCode = runConfig.currencyCode;
        }

        return currencyCode;
    }

    function getBaseUrlLocal(configOptions, runConfig) {
        if((configOptions.baseUrl && configOptions.env) && configOptions.baseUrl !== configOptions.env) {
            throw "Set only one parameter: baseUrl or env"
        }
        let baseUrl;

        if(typeof configOptions.baseUrl === 'string') {
            baseUrl = configOptions.baseUrl;
        } else if (typeof configOptions.env === 'string') {
            baseUrl = configOptions.env;
        } else {
            baseUrl = runConfig.baseUrl || '';
        }

        // IE doesn't support endsWith so we do it the hard way.
        if (baseUrl.length > 0 && baseUrl[length-1] === '/') {
            baseUrl = baseUrl.slice(0, baseUrl.length - 1);
        }

        return baseUrl;
    }

    function getRunConfig(_runConfig) {
        var returnConfig = _runConfig || {},
            storedConfig = getStorageObject() || {};

        for (var configKey in storedConfig) {
            if (storedConfig.hasOwnProperty(configKey)) {
                returnConfig[configKey] = storedConfig[configKey];
            }
        }

        return returnConfig;
    }

// ------------------------------------------------------
//
//              Exported values
//
// ------------------------------------------------------

    /**
     * Sets the runConfig to the config passed in. Clears out whatever might have already been there.
     *
     * @param config
     */
    var setRunConfig = function(config) {
        clearRunConfig();
        addRunConfig(config);
    };

    /**
     * Adds the configOptions fields into the run-config object in localStorage.
     *
     * @param configOptions
     */
    var addRunConfig = function(configOptions) {
        var runConfig = getStorageObject() || {};

        if (configOptions) {
            // needs to be done before configOptions is added to runConfig
            // runConfig.currencyCode = getCurrencyCode(configOptions.country, runConfig);
            // add configOptions to runConfig
            for (var configOption in configOptions) {
                if (configOptions.hasOwnProperty(configOption)) {
                    runConfig[configOption] = configOptions[configOption];
                }
            }

            runConfig.baseUrl = getBaseUrlLocal(configOptions, runConfig);

            if (configOptions.hasOwnProperty("assessmentApp")) {
                runConfig = setAssessmentAppMode(runConfig);
            }

            // sync up some nuskin.util settings
            if (configOptions.country) {
                if (nuskin && nuskin.util) {
                    nuskin.util.countryCode = configOptions.country;
                }
            }
            if (configOptions.language) {
                if (nuskin && nuskin.util) {
                    nuskin.util.languageCode = configOptions.language;
                }
            }
        } else {
            runConfig = null;
        }

        writeStorageObj(runConfig);

        return runConfig;
    };

    var clearRunConfig = function() {
        writeStorageObj(null);
    };

    /**
     *
     * @param alwaysReturnIt    defaults to true.  If set to false then the
     *                          baseUrl will not be returned if on mobile
     */
    var getBaseUrl = function(alwaysReturnIt) {
        var runConfig = getRunConfig(),
            baseUrl = '',
            returnIt = !(alwaysReturnIt === false && runConfig.assessmentApp === true);

        if (returnIt) {
            baseUrl = runConfig.baseUrl;
        }

        return baseUrl;
    };

    var setBaseUrl = function(baseUrl) {
        var runConfig = getRunConfig();
        runConfig.baseUrl = baseUrl;
        writeStorageObj(runConfig);
    };

    let removeProperty = function(property) {
        let runConfig = getRunConfig();

        delete runConfig[property];
        setRunConfig(runConfig);
    };

    /**
     * Environment Properties
     */
    let environment = {
        LOCALHOST: "localhost",
        LOCALHOST4502: "localhost:4502",
        LOCAL: "test.nuskin.com",
        TEST: "test.nuskin.com",
        TESTMYNUSKIN: "test.mynuskin.com", // For storefront in test
        DEV: "dev.nuskin.com",
        PROD: "www.nuskin.com",
        PRODMYNUSKIN: ".mynuskin.com", // For storefront in prod
        STAGE: "stage.nuskin.com"
    };

    let getEnvironment = function() {
        return getRunConfig().baseUrl;
    };

    let getEnvironmentCodeFromBaseUrl = function(runConfig) {
        runConfig = runConfig || getRunConfig();

        let env = "";
        if (runConfig && runConfig.baseUrl) {
            if (runConfig.baseUrl.indexOf(environment.DEV) > -1) {
                env = 'dev';
            } else if (runConfig.baseUrl.indexOf(environment.TEST) > -1 || runConfig.baseUrl.indexOf(environment.TESTMYNUSKIN) > -1 || runConfig.baseUrl.indexOf(environment.LOCALHOST) > -1 || runConfig.baseUrl.indexOf(environment.LOCALHOST4502) > -1) {
                env = 'test';
            } else if (runConfig.baseUrl.indexOf(environment.STAGE) > -1) {
                env = 'stage';
            } else if (runConfig.baseUrl.indexOf(environment.PROD) > -1 || runConfig.baseUrl.indexOf(environment.PRODMYNUSKIN) > -1) {
                env = 'prod'
            } else {
                env = 'unknown';
            }
        } else {
            env = 'unknown'
        }

        return env;
    };

    let getGateWayBaseURL = function() {
        let gateWayBaseURL;
        let environment = getEnvironmentCodeFromBaseUrl(getRunConfig());
        switch (environment) {
            case "dev":
                gateWayBaseURL = "https://devgw.nuskin.net";
                break;
            case "stage":
                gateWayBaseURL = "https://stagegw.nuskin.net";
                break;
            case "prod":
                gateWayBaseURL = "https://gw.nuskin.net";
                break;
            case "test":
            default:
                gateWayBaseURL = "https://testgw.nuskin.net";
                break;
        }

        return gateWayBaseURL;
    };

    let getEnvironmentCode = function() {
        let runConfig = getRunConfig();

        return runConfig.envCode || getEnvironmentCodeFromBaseUrl(runConfig);
    };

    return {
        LOCAL: environment.LOCAL,
        TEST: environment.TEST,
        DEV: environment.DEV,
        PROD: environment.PROD,
        STAGE: environment.STAGE,
        getEnvironment: getEnvironment,
        getEnvironmentCode: getEnvironmentCode,
        setRunConfig: setRunConfig,
        addRunConfig: addRunConfig,
        getRunConfig: getRunConfig,
        clearRunConfig: clearRunConfig,
        getBaseUrl: getBaseUrl,
        setBaseUrl: setBaseUrl,
        removeProperty: removeProperty,
        getGateWayBaseURL: getGateWayBaseURL
    }
}();

//setup default


export default runConfigService;


// for global namespace
// adding in nuskin.util
//nuskin.util.RunConfigService = runConfigService;




//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/runConfigService.js
// module id = 6
// module chunks = 0